//@ts-nocheck
import * as React from 'react';
import styled from "styled-components";
import { Heading2, IRISLightGreyDivider } from "./../Common/SharedStyledComponents";

const GovtReportHeader = (props: Props) => {
    const { report_university_name, heading_text } = props;
    return (
        <ContainerDiv>
            <div>
                <Heading2 bold center>{heading_text}</Heading2>
                <Heading2 center>{(report_university_name != "AGG_All_IRIS_Members") ? report_university_name : 'All IRIS Universities'}</Heading2>
            </div>
            <IRISLightGreyDivider />
        </ContainerDiv>
    );
}

const ContainerDiv = styled.div`
    width: 100%
`;

export default GovtReportHeader;